import { useEffect, useState } from 'react';
import Loader from './Loader';

function BootScreen({ isLoading, onShowPage }) {
  const [showBtn, setShowBtn] = useState(false);

  useEffect(function () {
    let timer = setTimeout(() => setShowBtn(true), 3000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="bootscreen d-flex align-items-center justify-content-center flex-column">
      <h1 className={`loader-text ${isLoading || !showBtn ? 'flash' : ''}`}>
        39! OS ver. kaypxz
      </h1>
      {isLoading || !showBtn ? (
        <Loader />
      ) : (
        <button className="loader-btn fadeIn" onClick={() => onShowPage(false)}>
          Log in as <span className="fw-b">Guest</span>
        </button>
      )}
    </div>
  );
}

export default BootScreen;
